<template>
  <div v-if="this.$route.name !== 'fundinglist'" class="row justify-content-between">
    <div class="col">
      <template>
        <h3>Aucune simulation sur cette période / filtre</h3>
      </template>
      <VueMultiselect
          class=""
          v-model="this.filter"
          :options="this.option.map((type) => type.value)"
          :custom-label="(opt) => this.option.find((x) => x.value === opt).text"
          label="Statut"
          :multiple="true"
          select-label=""
          remove-label=""
          placeholder="Filter les demandes"
      >
        <template  #noResult>
          <span class="font-weight-bold">Aucun filtre disponible.</span>
        </template>
      </VueMultiselect>
    </div>
  </div>

  <div v-if="loading"  class="containers">
    <div class="preloader"></div>
  </div>
    <el-table v-else :data="dataTable" :default-sort="{ prop: 'date_cre', order: 'descending' }"  @row-click="redirectToSimulation" lazy>
    <el-table-column v-if="this.$route.name !== 'funding'" prop="societe.name" label="Nom de la société" min-width="100" >
      <template #default="scope">
        <el-popover v-if="scope.row.societe?.idprof2" trigger="hover" placement="top" width="auto">
          <template #default>
            <div>Siret: {{ scope.row.societe?.idprof2 }}</div>
          </template>
          <template #reference>
            <router-link :to="{ name: 'funding', params: { id: scope.row.societe?.id } }">
              <span class="society">{{ scope.row.societe?.name }}</span>
            </router-link>
          </template>
        </el-popover>
      </template>
    </el-table-column>
    <el-table-column prop="reference" label="Référence" width="90" />
      <el-table-column v-if="hasMultipleCreator" class-name="font-weight-bold" label="Utilisateur" min-width="100">
        <template #default="scope">
          <el-popover trigger="hover" placement="top" width="auto">
            <template #default>
              <div>
                Date de création: <span>{{ formatDate(scope.row.date_cre) }}</span>
              </div>
            </template>
            <template #reference>
              <span>{{ `${scope.row.user.firstname} ${scope.row.user.lastname}` }}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
    <el-table-column label="Montant HT">
      <template #default="scope">
        <el-popover trigger="hover" placement="top" width="auto">
          <template #default>
            <div>Durée du contrat: {{ scope.row.duree }}</div>
            <div>
              Période: <span class="text-lowercase">{{ scope.row.opt_periodicite }}</span>
            </div>
            <span>Après échéance: {{ vueNumberFormat(scope.row.echeance, { thousand: ' ', precision: 2, suffix: ' €' }) }}</span>
          </template>
          <template #reference>
            <span>{{ vueNumberFormat(scope.row.montant, { thousand: ' ', precision: 2, suffix: ' €' }) }}</span>
          </template>
        </el-popover>
      </template>
    </el-table-column>
    <el-table-column class-name="font-weight-bold" label="Contrat" min-width="100">
      <template #default="scope">
        <span>{{ contractType[scope.row.fk_type_contrat].label ?? 'Type non reconnu' }}</span>
      </template>
    </el-table-column>

    <el-table-column prop="date_cre" label="Création" min-width="80">
      <template #default="scope">
        <span>{{ formatDate(scope.row.date_cre) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="" width="50">
    </el-table-column>
    <el-table-column label="Avancement du dossier" width="400" align="center">
      <template #default="scope">
        <InternalStepper :row="scope.row" />
      </template>
    </el-table-column>
  </el-table>
  <el-pagination v-if="!loading"
    background
    layout="prev, pager, next, sizes"
    :page-sizes="[5, 10, 20, 50, 100]"
    v-model:page-size="maxElem"
    :current-page="pagination?.page + 1 ?? 1"
    @current-change="handleChange"
    @size-change="handleSizeChange"
    :total="paginationTotal"
    class="my-4 justify-content-center"
  >
  </el-pagination>
</template>

<script>


import moment from 'moment';
import Funding from '../class/funding';
import VueMultiselect from 'vue-multiselect';
import InternalStepper from './DataTableStepper';
import {isMobileOnly} from "mobile-device-detect";
import {STATUS_OPTIONS} from "@/utils/statusOptions";

export default {
  name: 'DataTable',
  components: {InternalStepper, VueMultiselect },
  emits: ['changePage', 'filterData','removeSimulation'],
  props: {
    dataTable: { required: true },
    pagination: {
      required: false,
    },
    loading: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      contractType: this.$store.getters.getContractTypes,
      removeSimulation: true,
      step: 2,
      maxElem: 10,
      funding: Funding,
      filter: [],
      page: 1,
      option: STATUS_OPTIONS
    };
  },
  mounted() {
    this.$emit('filterData', {filters: '', limit: this.maxElem});
  },
  computed: {
    hasMultipleCreator() {
      const user_simulations = this.dataTable.filter((value, index, self) =>
          index === self.findIndex((t) => (
              t.user.firstname === value.user.firstname && t.user.lastname === value.user.lastname
          )));
      return user_simulations.length > 1;
    },
    paginationTotal() {
      return this.pagination?.item_count ?? 0;
    },
    encodedFilterQuery() {
      let filtersQuery = '';
      this.filter.map((filter, key) => {
        const filterRaw = this.option.find(opt => opt.value === filter);
        const operator = key === 0 ? '' : ' or ';
        filtersQuery += `${operator}${filterRaw.filterValue}`
      })
      return filtersQuery;
    },
    encodedFilter() {
      let filtersQuery = '';
      this.filter.map((filter, key) => {
        const filterRaw = this.option.find(opt => opt.value === filter);
        const operator = key === 0 ? '' : ' or ';
        filtersQuery += `${operator}${filterRaw.value}`
      })
      return filtersQuery;
    },
  },
  watch: {
    filter() {
      history.pushState({}, null, (this.filter.length) ? `?filter=${this.encodedFilter}` : this.$route.path);
      this.$emit('filterData', {filters: this.encodedFilterQuery, limit: this.maxElem});
    }
  },
  methods: {
    isMobileOnly() {
      return isMobileOnly
    },
    redirectToSimulation(row) {
      this.$router.push({ name: 'custommerFunding', params: { id: row.societe.id, idFunding: row.rowid } });
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    handleChange(page, size) {
      this.$emit('changePage', { size: size ? size : this.maxElem, page: page, filters: this.encodedFilterQuery });
    },
    handleSizeChange(newSize) {
      this.page = 1;
      this.handleChange(this.page, newSize);
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.containers{
  max-width: 400px;
  margin: 10rem auto;
}

.preloader {
  margin: 20% auto 0;
  transform: translateZ(0);
}

.preloader:before,
.preloader:after {
  content: '';
  position: absolute;
  top: 0;
}

.preloader:before,
.preloader:after,
.preloader {
  border-radius: 50%;
  width: 2em;
  height: 2em;
  animation: animation 1.2s infinite ease-in-out;
}

.preloader {
  animation-delay: -0.16s;
}

.preloader:before {
  left: -3.5em;
  animation-delay: -0.32s;
}

.preloader:after {
  left: 3.5em;
}

@keyframes animation {
  0%,
  80%,
  100% {
    box-shadow: 0 2em 0 -1em #464b5f;
  }
  40% {
    box-shadow: 0 2em 0 0 #6e398e;
  }
}
.containers {
  position: absolute;
  left: 0;
  right: 0;
}
.containers:before {
  content: "";
  height: 100%;
  display: inline-block;
  vertical-align: middle;
}

.society {
  font-weight: 700;
}
</style>
